import { useState, useEffect } from 'react';
import moment from 'moment';
import commitmentService from '~/services/commitmentService';
import { isNewVisitHistoryCore } from '~/services/coreConfig';

export function useVisitData() {
  const [visits, setVisits] = useState([]);
  const [loadingAppointments, setLoadingAppointments] = useState(true);
  const [loadingVisitId, setLoadingVisitId] = useState(null);
  const [tableLoading, setTableLoading] = useState(false);
  const [pageDim, setPageDim] = useState(false);

  const mapAppointmentToVisit = a => {
    const start = a.StartDateTime ? moment(a.StartDateTime).local() : null;
    const date = start ? start.format('DD/MM/YYYY [às] HH:mm') : a.date || '';
    const subjectRaw = a.Subject || a.subject || '';
    const subject = (subjectRaw || '').replace(/\s*\/\s*/g, '\n');
    const rating = Number.isInteger(a.visitRating)
      ? a.visitRating
      : typeof a.rating === 'number'
      ? a.rating
      : null;
    const hasRating = Number.isInteger(a.visitRating)
      ? true
      : typeof a.rating === 'number';

    return {
      id: a.Id || a.id,
      status: a.Status_da_Visita__c || a.status || '',
      date,
      subject,
      rating,
      hasRating,
      tags: a.tags || [],
      description: a.Description || a.description || '',
      consultant: a.OwnerName || a.consultant || '',
      raw: a,
    };
  };

  const fetchAppointments = async () => {
    try {
      setLoadingAppointments(true);
      const core = localStorage.getItem('core');
      const isNewCore = isNewVisitHistoryCore(core);

      // Data mínima padrão para histórico
      const defaultStartDate = '2025-12-15';
      const newCoresStartDate = '2026-03-12'; // 12/03/2025
      const startDate = isNewCore ? newCoresStartDate : defaultStartDate;
      const endDate = (() => {
        const d = new Date();
        d.setFullYear(d.getFullYear() + 1);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      })();

      const res = await commitmentService.getAppointmentList({
        startDate,
        endDate,
        storeId: localStorage.getItem('storeId'),
        // storeId: '0013000001MDsVWAA1'
      });

      const data = res && res.data ? res.data : [];
      const items = data.appointments || data || [];
      const mapped = Array.isArray(items)
        ? items.map(mapAppointmentToVisit)
        : [];
      setVisits(mapped);
    } catch (err) {
      console.debug('Erro ao buscar visitas (appointment list)', err);
    } finally {
      setLoadingAppointments(false);
    }
  };

  useEffect(() => {
    fetchAppointments();
  }, []);

  const handleAfterCommitmentUpdate = async () => {
    setTableLoading(true);
    try {
      await fetchAppointments();
    } catch (e) {
      console.error('Erro ao re-carregar visitas após atualização', e);
    } finally {
      setTableLoading(false);
      setPageDim(false);
    }
  };

  const handleStartSubmit = () => {
    setPageDim(true);
  };

  return {
    visits,
    setVisits,
    loadingAppointments,
    setLoadingAppointments,
    loadingVisitId,
    setLoadingVisitId,
    tableLoading,
    setTableLoading,
    pageDim,
    setPageDim,
    fetchAppointments,
    handleAfterCommitmentUpdate,
    handleStartSubmit,
    mapAppointmentToVisit,
  };
}
